module.exports = __webpack_public_path__ + "img/11.474b06b.png";